import { Navigate } from "react-router-dom";

// Auth
import Login from "pages/Authentication/login";
import Logout from "pages/Authentication/Logout";
import ForgotPassword from "pages/Authentication/ForgotPassword";
import SignUp from "pages/Authentication/Register";

// PROTECTECTED ROUTES
import Dashboard from "../pages/Dashboard";
import Accounts from "../pages/Dashboard/Dashboard-accounts";
import Cards from "pages/Cards";
import Acquisition from "pages/Dashboard/Dashboard-acquisition";
import PaymentServices from "pages/Payment-services";
import MyAccounts from "pages/MyAccounts";
import CryptoWallet from "pages/CryptoWallet/crypto-wallet";
import MassTransfers from "pages/Mass-transfers";
import Credits from "pages/Credits";
import DigitalAssets from "pages/Digital-assets";
import CardAcquirance from "pages/Card-acquirance";
import Roles from "pages/Roles";
import UserSystem from "pages/Users-system";
import CompanyData from "pages/Company-data";
import Notifications from "pages/Notifications";
import DashboardCards from "pages/Dashboard/Dashboard-cards";
import NotificationRead from "pages/Notifications/notification-read";
import BillDetails from "pages/Payment-services/Bill-details";
import CreditDetails from "pages/Credits/Bill-details";
import ApplyCredit from "pages/Credits/ApplyCredit/applyCredit";
import ListDetails from "pages/Mass-transfers/list-details";
import ListPay from "pages/Mass-transfers/list-pay";
import TransferReport from "pages/Mass-transfers/repote";
import Remittances from "pages/Remittances";
import DigitalCorrespondet from "pages/Digital-correspondent";
import CreditOrigination from "pages/Credit-origination";
import Suscriptions from "pages/Card-acquirance/suscriptions";
import PaymentLink from "pages/Card-acquirance/payment-link";
import PaymentButton from "pages/Card-acquirance/payment-button";
import Appereance from "pages/Card-acquirance/appereance";
import CardInformation from "pages/Card-acquirance/card-information";
import SecurityView from "pages/Security";
import RegisterForm from "pages/Authentication/RegisterForm";
import TwostepVerification from "pages/Authentication/auth-two-step-verification";
import ResetPassword from "pages/Authentication/ResetPassword";
import EntityForm from "pages/Authentication/EntityRegister";
import UserProfile from "pages/Authentication/user-profile";
import EmailVerification from "pages/Authentication/verify-email";
import StepsRegister from "pages/Authentication/IndividualSteps/stepsRegistrationIndividual";
import SelectionType from "pages/Authentication/selectionType";
import ConfirmMail from "pages/Authentication/IndividualSteps/page-confirm-mail";
import StepsRegisterBusiness from "pages/Authentication/BusinessSteps/stepsRegistrationBusiness";
import ConfirmMailBusiness from "pages/Authentication/BusinessSteps/page-confirm-mail";
import NoAccessSystem from "pages/Authentication/noAccessSystem";

// MANDO A LLAMAR LOS ROLES DE LAN ENTIDAD Y LOS DEFAULT

const authProtectedRoutes = [
  //Dashboard
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  { path: "/profile", component: <UserProfile /> },
  { path: "/Accounts", component: <Accounts /> },
  { path: "/dashboard-cards", component: <DashboardCards /> },
  {
    path: "/Acquisition",
    component: <Acquisition />,
  },

  //Cards
  { path: "/Cards", component: <Cards />, permissions: ["WA0001"] }, //roles: ["admin", "user"]

  //Payment Services
  {
    path: "/paymentService",
    component: <PaymentServices />,
    permissions: ["WA0001"],
  },
  {
    path: "/bill-details",
    component: <BillDetails />,
    permissions: ["VIEW_BILL_DETAILS"],
  },

  //My Accounts
  {
    path: "/myaccounts",
    component: <MyAccounts />,
    permissions: ["MA0001"], //QUITAR ESTO PARA CUANDO TRABAJE
  },

  //Crypto Wallet
  {
    path: "/wallet",
    component: <CryptoWallet />,
    permissions: ["WA0001"], //QUITAR ESTO PARA CUANDO TRABAJE
  },

  //KYC verification
  // { path: "/crypto-kyc-application", component: <CryptoKYCApplication /> },

  //Mass Transfers
  {
    path: "/mass-transfers",
    component: <MassTransfers />,
    permissions: ["WA0001"],
  },
  {
    path: "/list-details",
    component: <ListDetails />,
    permissions: ["VIEW_MASSTRANSFERS"],
  },
  {
    path: "/pay-list",
    component: <ListPay />,
    permissions: ["VIEW_MASSTRANSFERS"],
  },
  {
    path: "/report-transfer",
    component: <TransferReport />,
    permissions: ["VIEW_MASSTRANSFERS"],
  },

  //Creditos
  {
    path: "/credits",
    component: <Credits />,
    permissions: ["VIEW_CREDITS"],
  },
  {
    path: "/credit-detail",
    component: <CreditDetails />,
    permissions: ["VIEW_CREDITS"],
  },
  {
    path: "/apply-credit",
    component: <ApplyCredit />,
    permissions: ["VIEW_CREDITS"],
  },

  //Digital Assets
  {
    path: "/digital-assets",
    component: <DigitalAssets />,
    permissions: ["VIEW_DIGITAL_ASSETS"],
  },

  //Card aquirance
  {
    path: "/card-aquirance",
    component: <CardAcquirance />,
    permissions: ["VIEW_CARD_AQUIRANCE"],
  },
  {
    path: "/payment-link",
    component: <PaymentLink />,
    permissions: ["VIEW_CARD_AQUIRANCE"],
  },
  {
    path: "/payment-button",
    component: <PaymentButton />,
    permissions: ["VIEW_CARD_AQUIRANCE"],
  },
  {
    path: "/suscriptions",
    component: <Suscriptions />,
    permissions: ["VIEW_SUSCRIPTIONS"],
  },
  {
    path: "/appereance",
    component: <Appereance />,
    permissions: ["VIEW_APPEREANCE"],
  },
  {
    path: "/card-information",
    component: <CardInformation />,
    permissions: ["VIEW_CARD_INFORMATION"],
  },

  //Roles
  {
    path: "/roles",
    component: <Roles />,
    permissions: ["RO0001"],
  },
  {
    path: "/user-system",
    component: <UserSystem />,
    // permissions: ["US0001"],
  },
  {
    path: "/company-data",
    component: <CompanyData />,
    permissions: ["VIEW_COMPANY_DATA"],
  },

  //Notifications
  {
    path: "/notifications",
    component: <Notifications />,
    permissions: ["NO0001"],
  },
  {
    path: "/notification-read/:id?",
    component: <NotificationRead />,
    permissions: ["NO0001"],
  },

  //Remittances
  {
    path: "/remittances",
    component: <Remittances />,
    permissions: ["VIEW_REMITTANCES"],
  },

  //Seguridad
  {
    path: "/security",
    component: <SecurityView />,
    permissions: ["SE0001"],
  },

  //Digital Correspondet
  {
    path: "/digital-correspondet",
    component: <DigitalCorrespondet />,
    permissions: ["VIEW_DIGITAL_CORRESPONDENT"],
  },

  //Credit Origination
  {
    path: "/credit-origination",
    component: <CreditOrigination />,
    permissions: ["VIEW_CREDIT_ORIGINATION"],
  },

  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/register", component: <SignUp /> },
  { path: "/registerform", component: <RegisterForm /> },
  { path: "/entity-form", component: <EntityForm /> },
  { path: "/reset-password/:token?", component: <ResetPassword /> },
  { path: "/auth-two-step-verification", component: <TwostepVerification /> },
  { path: "/verify-account/:token?", component: <EmailVerification /> }, //QUEDA INVALIDADA ESTA URL (Ya no se utilizara debido a que el usuario verifica su cuenta con el OTP)
  { path: "/no-access-system", component: <NoAccessSystem /> },
  { path: "/select-type", component: <SelectionType /> },
  { path: "/individual-registration", component: <StepsRegister /> },
  { path: "/individual-confirmation", component: <ConfirmMail /> },
  { path: "/business-registration", component: <StepsRegisterBusiness /> },
  { path: "/business-confirmation", component: <ConfirmMailBusiness /> },
];
export { authProtectedRoutes, publicRoutes };
